export default "__VITE_ASSET__D_JL8PMW__"